<div class="row titulo-modal justify-content-between align-items-center" mat-dialog-title>
	<h3 class="col mb-0 text-center mt-3">
		Cambiar tu contraseña
	</h3>
</div>
<mat-dialog-content>
	<div class="row">
		<div class="col-md-12 text-center">
			<mat-icon class="icono-grande">vpn_key</mat-icon>
		</div>
	</div>
	<!-- <mat-error *ngIf="existeError !== null" class="text-justify">
		{{existeError}}
	</mat-error> -->
	<form class="my-3 row" [formGroup]="form" autocomplete="off">
		<div class="col-md-12 ">
			<mat-form-field class="formulario">
				<mat-label>Escribe tu actual contraseña</mat-label>
				<input matInput [type]="hide ? 'password' : 'text'" formControlName="passAnterio" maxlength="12">
				<button type="button" mat-icon-button matSuffix (click)="hide = !hide">
					<i class="iconoOjo fa fa-eye" *ngIf="!hide"></i>
					<i class="iconoOjo fa fa-eye-slash" *ngIf="hide"></i>
				</button>
			</mat-form-field>
		</div>
		<div class="col-md-12 mt-3">
			<mat-form-field class="formulario">
				<mat-label>Escribe tu nueva contraseña</mat-label>
				<input matInput [type]="hideTres ? 'password' : 'text'" formControlName="newPassword" minlength="8"
					maxlength="16" autocomplete="new-password">
				<button type="button" mat-icon-button matSuffix (click)="hideTres = !hideTres">
					<i class="iconoOjo fa fa-eye" *ngIf="!hideTres"></i>
					<i class="iconoOjo fa fa-eye-slash" *ngIf="hideTres"></i>
				</button>
			</mat-form-field>
			<div class="password-requirements small text-muted mt-1">
				La longitud mínima es de 8 caracteres, la contraseña debe de tener por lo menos una letra mayúscula,
				minúscula, un símbolo de los siguientes  &#64;$%#&.-  y un número.
			</div>
		</div>
		<div class="col-md-12 mt-5 mb-3">
			<mat-form-field class="formulario">
				<mat-label>Confirma tu nueva contraseña</mat-label>
				<input matInput [type]="hideDos ? 'password' : 'text'" formControlName="confirmacion" minlength="8"
					maxlength="16" autocomplete="new-password">
				<button type="button" mat-icon-button matSuffix (click)="hideDos = !hideDos">
					<i class="iconoOjo fa fa-eye" *ngIf="!hideDos"></i>
					<i class="iconoOjo fa fa-eye-slash" *ngIf="hideDos"></i>
				</button>
				<mat-error *ngIf="form.errors?.noIguales && form.get('confirmacion').touched">
					Las contraseñas no son iguales
				</mat-error>
			</mat-form-field>
		</div>
		<div class="col-12 mt-3">
			<button class="btn-block btn-alternativo" [disabled]="form.invalid" mat-raised-button type="submit"
				color="primary" (click)="cambiarPass()">
				Cambiar contraseña
			</button>
		</div>
	</form>

</mat-dialog-content>